import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    convertedIngestBatch: build.mutation<
      ConvertedIngestBatchApiResponse,
      ConvertedIngestBatchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/converted-ingest`,
        method: "POST",
        body: queryArg.convertedIngestRequest,
      }),
    }),
    convertedUploadEnvelopes: build.mutation<
      ConvertedUploadEnvelopesApiResponse,
      ConvertedUploadEnvelopesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/converted-upload`,
        method: "POST",
        body: queryArg.convertedUploadFormData,
      }),
    }),
    listOrganizationImportSessions: build.query<
      ListOrganizationImportSessionsApiResponse,
      ListOrganizationImportSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/organizations/${queryArg.organizationId}/import-sessions`,
      }),
    }),
    listOrgRawUploads: build.query<
      ListOrgRawUploadsApiResponse,
      ListOrgRawUploadsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/organizations/${queryArg.organizationId}/raw-uploads`,
      }),
    }),
    mergeMultiplePatients: build.mutation<
      MergeMultiplePatientsApiResponse,
      MergeMultiplePatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/patients/merge-multiple`,
        method: "POST",
        body: queryArg.mergeMultiplePatientsRequest,
      }),
    }),
    rawUploadImportFile: build.mutation<
      RawUploadImportFileApiResponse,
      RawUploadImportFileApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/raw-upload`,
        method: "POST",
        body: queryArg.importUploadFormData,
      }),
    }),
    presignRawUploadUrls: build.mutation<
      PresignRawUploadUrlsApiResponse,
      PresignRawUploadUrlsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/raw-upload-urls`,
        method: "POST",
        body: queryArg.presignRawUploadRequest,
      }),
    }),
    listResourceImportSessions: build.query<
      ListResourceImportSessionsApiResponse,
      ListResourceImportSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/resource-sessions`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    deleteImportSession: build.mutation<
      DeleteImportSessionApiResponse,
      DeleteImportSessionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}`,
        method: "DELETE",
      }),
    }),
    getImportSessionStatus: build.query<
      GetImportSessionStatusApiResponse,
      GetImportSessionStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}`,
      }),
    }),
    getSessionArtifactContent: build.query<
      GetSessionArtifactContentApiResponse,
      GetSessionArtifactContentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/artifacts/content`,
        params: {
          organization_id: queryArg.organizationId,
          key: queryArg.key,
        },
      }),
    }),
    downloadSessionArtifact: build.query<
      DownloadSessionArtifactApiResponse,
      DownloadSessionArtifactApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/artifacts/download`,
        params: {
          organization_id: queryArg.organizationId,
          key: queryArg.key,
        },
      }),
    }),
    requestClassify: build.mutation<
      RequestClassifyApiResponse,
      RequestClassifyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/classify`,
        method: "POST",
        body: queryArg.stagedResourcesOrgParams,
      }),
    }),
    getClassifySummary: build.query<
      GetClassifySummaryApiResponse,
      GetClassifySummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/classify-summary`,
        params: {
          organization_id: queryArg.organizationId,
          status: queryArg.status,
        },
      }),
    }),
    listClassifyConflicts: build.query<
      ListClassifyConflictsApiResponse,
      ListClassifyConflictsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/conflicts`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          organization_id: queryArg.organizationId,
          resource_type: queryArg.resourceType,
        },
      }),
    }),
    exportImportResults: build.query<
      ExportImportResultsApiResponse,
      ExportImportResultsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/export`,
      }),
    }),
    importSelectedPatients: build.mutation<
      ImportSelectedPatientsApiResponse,
      ImportSelectedPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/import`,
        method: "POST",
        body: queryArg.extractedPatientsRequest,
      }),
    }),
    listImportOperations: build.query<
      ListImportOperationsApiResponse,
      ListImportOperationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/import-operations`,
      }),
    }),
    getImportOperationStatus: build.query<
      GetImportOperationStatusApiResponse,
      GetImportOperationStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/import-operations/${queryArg.operationId}`,
      }),
    }),
    importUnmatchedPatients: build.mutation<
      ImportUnmatchedPatientsApiResponse,
      ImportUnmatchedPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/import-unmatched`,
        method: "POST",
        body: queryArg.importUnmatchedRequest,
      }),
    }),
    getMatchedPatients: build.query<
      GetMatchedPatientsApiResponse,
      GetMatchedPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/matched-patients`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
          status: queryArg.status,
        },
      }),
    }),
    listSessionPatients: build.query<
      ListSessionPatientsApiResponse,
      ListSessionPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/patients`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    bulkUpdatePatientStatus: build.mutation<
      BulkUpdatePatientStatusApiResponse,
      BulkUpdatePatientStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/patients`,
        method: "PATCH",
        body: queryArg.bulkUpdateStatusRequest,
      }),
    }),
    listSessionPatientMatches: build.query<
      ListSessionPatientMatchesApiResponse,
      ListSessionPatientMatchesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/patients/matches`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    listSourceProviders: build.query<
      ListSourceProvidersApiResponse,
      ListSourceProvidersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/providers`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    rejectPatients: build.mutation<
      RejectPatientsApiResponse,
      RejectPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/reject`,
        method: "POST",
        body: queryArg.rejectPatientsRequest,
      }),
    }),
    listStagedResources: build.query<
      ListStagedResourcesApiResponse,
      ListStagedResourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/resources`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          organization_id: queryArg.organizationId,
          resource_type: queryArg.resourceType,
          status: queryArg.status,
          search: queryArg.search,
          verdict: queryArg.verdict,
          selected: queryArg.selected,
          org_review_needed: queryArg.orgReviewNeeded,
        },
      }),
    }),
    commitStagedResources: build.mutation<
      CommitStagedResourcesApiResponse,
      CommitStagedResourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/resources/commit`,
        method: "POST",
        body: queryArg.commitStagedResourcesRequest,
      }),
    }),
    setStagedResourcesOrgReview: build.mutation<
      SetStagedResourcesOrgReviewApiResponse,
      SetStagedResourcesOrgReviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/resources/org-review`,
        method: "POST",
        body: queryArg.setOrgReviewRequest,
      }),
    }),
    selectStagedResources: build.mutation<
      SelectStagedResourcesApiResponse,
      SelectStagedResourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/resources/select`,
        method: "POST",
        body: queryArg.selectStagedResourcesRequest,
      }),
    }),
    clearStagedResourcesSelection: build.mutation<
      ClearStagedResourcesSelectionApiResponse,
      ClearStagedResourcesSelectionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/resources/selection/clear`,
        method: "POST",
        body: queryArg.clearSelectionRequest,
      }),
    }),
    getStagedResourcesSummary: build.query<
      GetStagedResourcesSummaryApiResponse,
      GetStagedResourcesSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/resources/summary`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    getStagedResourceDocument: build.query<
      GetStagedResourceDocumentApiResponse,
      GetStagedResourceDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/resources/${queryArg.importResourceId}/document`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    uploadImportFile: build.mutation<
      UploadImportFileApiResponse,
      UploadImportFileApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/upload`,
        method: "POST",
        body: queryArg.importUploadFormData,
      }),
    }),
    listOrgReviewPending: build.query<
      ListOrgReviewPendingApiResponse,
      ListOrgReviewPendingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/org-review/pending`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          resource_type: queryArg.resourceType,
        },
      }),
    }),
    resolveOrgReviewRow: build.mutation<
      ResolveOrgReviewRowApiResponse,
      ResolveOrgReviewRowApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/org-review/${queryArg.importResourceId}/resolve`,
        method: "POST",
        body: queryArg.orgReviewResolveRequest,
      }),
    }),
    postV2ProviderDataMigrationPatientsDeduplicate: build.mutation<
      PostV2ProviderDataMigrationPatientsDeduplicateApiResponse,
      PostV2ProviderDataMigrationPatientsDeduplicateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/patients/deduplicate`,
        method: "POST",
        body: queryArg.findDuplicatesRequest,
      }),
    }),
    postV2ProviderDataMigrationPatientsDeduplicateAutoMergeCandidates:
      build.mutation<
        PostV2ProviderDataMigrationPatientsDeduplicateAutoMergeCandidatesApiResponse,
        PostV2ProviderDataMigrationPatientsDeduplicateAutoMergeCandidatesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/data-migration/patients/deduplicate/auto-merge-candidates`,
          method: "POST",
          body: queryArg.findAutoMergeCandidatesRequest,
        }),
      }),
    postV2ProviderDataMigrationPatientsDeduplicateBatchMerge: build.mutation<
      PostV2ProviderDataMigrationPatientsDeduplicateBatchMergeApiResponse,
      PostV2ProviderDataMigrationPatientsDeduplicateBatchMergeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/patients/deduplicate/batch-merge`,
        method: "POST",
        body: queryArg.batchMergeRequest,
      }),
    }),
    getV2ProviderDataMigrationPatientsDeduplicateBatchMergeByJobId: build.query<
      GetV2ProviderDataMigrationPatientsDeduplicateBatchMergeByJobIdApiResponse,
      GetV2ProviderDataMigrationPatientsDeduplicateBatchMergeByJobIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/patients/deduplicate/batch-merge/${queryArg.jobId}`,
      }),
    }),
    postV2ProviderDataMigrationPatientsDeduplicateDismiss: build.mutation<
      PostV2ProviderDataMigrationPatientsDeduplicateDismissApiResponse,
      PostV2ProviderDataMigrationPatientsDeduplicateDismissApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/patients/deduplicate/dismiss`,
        method: "POST",
        body: queryArg.dismissDuplicateRequest,
      }),
    }),
    postV2ProviderDataMigrationPatientsDeduplicateMerge: build.mutation<
      PostV2ProviderDataMigrationPatientsDeduplicateMergeApiResponse,
      PostV2ProviderDataMigrationPatientsDeduplicateMergeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/patients/deduplicate/merge`,
        method: "POST",
        body: queryArg.mergeGroupRequest,
      }),
    }),
    providerListImportSessions: build.query<
      ProviderListImportSessionsApiResponse,
      ProviderListImportSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions`,
        params: {
          status_filter: queryArg.statusFilter,
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    providerDeleteImportSession: build.mutation<
      ProviderDeleteImportSessionApiResponse,
      ProviderDeleteImportSessionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions/${queryArg.sessionId}`,
        method: "DELETE",
      }),
    }),
    providerGetImportSessionStatus: build.query<
      ProviderGetImportSessionStatusApiResponse,
      ProviderGetImportSessionStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions/${queryArg.sessionId}`,
      }),
    }),
    approveCsvImport: build.mutation<
      ApproveCsvImportApiResponse,
      ApproveCsvImportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions/${queryArg.sessionId}/approve-import`,
        method: "POST",
      }),
    }),
    getExtractedPatientsForReview: build.query<
      GetExtractedPatientsForReviewApiResponse,
      GetExtractedPatientsForReviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions/${queryArg.sessionId}/extracted-patients`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    approveReviewWizard: build.mutation<
      ApproveReviewWizardApiResponse,
      ApproveReviewWizardApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions/${queryArg.sessionId}/review/approve`,
        method: "POST",
        body: queryArg.reviewApproveRequest,
      }),
    }),
    getReviewPatients: build.query<
      GetReviewPatientsApiResponse,
      GetReviewPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions/${queryArg.sessionId}/review/patients`,
        params: {
          phase: queryArg.phase,
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    getReviewSummary: build.query<
      GetReviewSummaryApiResponse,
      GetReviewSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions/${queryArg.sessionId}/review/summary`,
      }),
    }),
    providerUploadImportFile: build.mutation<
      ProviderUploadImportFileApiResponse,
      ProviderUploadImportFileApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/upload`,
        method: "POST",
        body: queryArg.importUploadFormData,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type ConvertedIngestBatchApiResponse =
  /** status 200 OK */ ConvertedIngestResponse;
export type ConvertedIngestBatchApiArg = {
  convertedIngestRequest: ConvertedIngestRequest;
};
export type ConvertedUploadEnvelopesApiResponse =
  /** status 200 OK */ ConvertedUploadResponse;
export type ConvertedUploadEnvelopesApiArg = {
  convertedUploadFormData: ConvertedUploadFormData;
};
export type ListOrganizationImportSessionsApiResponse =
  /** status 200 OK */ ImportSessionListResponse;
export type ListOrganizationImportSessionsApiArg = {
  organizationId: string;
};
export type ListOrgRawUploadsApiResponse =
  /** status 200 OK */ RawUploadListResponse;
export type ListOrgRawUploadsApiArg = {
  organizationId: string;
};
export type MergeMultiplePatientsApiResponse =
  /** status 200 OK */ MergeMultiplePatientsResponse;
export type MergeMultiplePatientsApiArg = {
  mergeMultiplePatientsRequest: MergeMultiplePatientsRequest;
};
export type RawUploadImportFileApiResponse =
  /** status 200 OK */ RawUploadResponse;
export type RawUploadImportFileApiArg = {
  importUploadFormData: ImportUploadFormData;
};
export type PresignRawUploadUrlsApiResponse =
  /** status 200 OK */ PresignRawUploadResponse;
export type PresignRawUploadUrlsApiArg = {
  presignRawUploadRequest: PresignRawUploadRequest;
};
export type ListResourceImportSessionsApiResponse =
  /** status 200 OK */ ResourceImportSessionsListResponse;
export type ListResourceImportSessionsApiArg = {
  /** Organization UUID */
  organizationId: string;
};
export type DeleteImportSessionApiResponse = unknown;
export type DeleteImportSessionApiArg = {
  sessionId: string;
};
export type GetImportSessionStatusApiResponse =
  /** status 200 OK */ ImportSessionStatusResponse2;
export type GetImportSessionStatusApiArg = {
  sessionId: string;
};
export type GetSessionArtifactContentApiResponse =
  /** status 200 OK */ ArtifactContentResponse;
export type GetSessionArtifactContentApiArg = {
  sessionId: string;
  /** Organization UUID */
  organizationId: string;
  /** S3 object key of the artifact to download; must be one of the session's recorded artifact_keys */
  key: string;
};
export type DownloadSessionArtifactApiResponse =
  /** status 200 OK */ ArtifactDownloadResponse;
export type DownloadSessionArtifactApiArg = {
  sessionId: string;
  /** Organization UUID */
  organizationId: string;
  /** S3 object key of the artifact to download; must be one of the session's recorded artifact_keys */
  key: string;
};
export type RequestClassifyApiResponse =
  /** status 200 OK */ ClassifyRequestedResponse;
export type RequestClassifyApiArg = {
  sessionId: string;
  stagedResourcesOrgParams: StagedResourcesOrgParams;
};
export type GetClassifySummaryApiResponse =
  /** status 200 OK */ ClassifySummaryResponse;
export type GetClassifySummaryApiArg = {
  sessionId: string;
  /** Organization UUID */
  organizationId: string;
  /** Scope verdict counts to a review view (GDN-2270): 'pending' = the not-yet-committed queue (keeps unprocessable/escalated lanes), 'committed' = already committed. Omit or 'all' counts every row. */
  status?: ("pending" | "committed" | "all") | null;
};
export type ListClassifyConflictsApiResponse =
  /** status 200 OK */ ConflictListResponse;
export type ListClassifyConflictsApiArg = {
  sessionId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Organization UUID */
  organizationId: string;
  /** Filter to one resource type (e.g. 'patient') */
  resourceType?: string | null;
};
export type ExportImportResultsApiResponse =
  /** status 200 OK */ MigratedDataResponse;
export type ExportImportResultsApiArg = {
  sessionId: string;
};
export type ImportSelectedPatientsApiResponse =
  /** status 200 OK */ ExtractedPatientsResponse;
export type ImportSelectedPatientsApiArg = {
  sessionId: string;
  extractedPatientsRequest: ExtractedPatientsRequest;
};
export type ListImportOperationsApiResponse =
  /** status 200 OK */ ImportOperationListResponse;
export type ListImportOperationsApiArg = {
  sessionId: string;
};
export type GetImportOperationStatusApiResponse =
  /** status 200 OK */ ImportOperationStatusResponse2;
export type GetImportOperationStatusApiArg = {
  sessionId: string;
  operationId: string;
};
export type ImportUnmatchedPatientsApiResponse =
  /** status 200 OK */ ImportUnmatchedResponse;
export type ImportUnmatchedPatientsApiArg = {
  sessionId: string;
  importUnmatchedRequest: ImportUnmatchedRequest;
};
export type GetMatchedPatientsApiResponse =
  /** status 200 OK */ MatchedPatientsResponse;
export type GetMatchedPatientsApiArg = {
  sessionId: string;
  /** Maximum number of patients to return */
  limit?: number;
  /** Number of patients to skip for pagination */
  offset?: number;
  /** Filter by import status (e.g., 'NEW', 'MATCHED', 'IMPORTED') */
  status?: string | null;
};
export type ListSessionPatientsApiResponse =
  /** status 200 OK */ SessionPatientsListResponse;
export type ListSessionPatientsApiArg = {
  sessionId: string;
  /** Organization UUID */
  organizationId: string;
};
export type BulkUpdatePatientStatusApiResponse =
  /** status 200 OK */ BulkUpdateStatusResponse;
export type BulkUpdatePatientStatusApiArg = {
  sessionId: string;
  bulkUpdateStatusRequest: BulkUpdateStatusRequest;
};
export type ListSessionPatientMatchesApiResponse =
  /** status 200 OK */ SessionPatientMatchesListResponse;
export type ListSessionPatientMatchesApiArg = {
  sessionId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Organization UUID */
  organizationId: string;
};
export type ListSourceProvidersApiResponse =
  /** status 200 OK */ SourceProvidersListResponse;
export type ListSourceProvidersApiArg = {
  sessionId: string;
  /** Organization UUID */
  organizationId: string;
};
export type RejectPatientsApiResponse =
  /** status 200 OK */ RejectPatientsResponse;
export type RejectPatientsApiArg = {
  sessionId: string;
  rejectPatientsRequest: RejectPatientsRequest;
};
export type ListStagedResourcesApiResponse =
  /** status 200 OK */ ListResponseStagedResourceSchema;
export type ListStagedResourcesApiArg = {
  sessionId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Organization UUID */
  organizationId: string;
  /** Filter by resource type (e.g. 'patient') */
  resourceType?: string | null;
  /** Filter by staging status (staged|invalid|committed|skipped) */
  status?: string | null;
  /** Case-insensitive substring match on the plaintext source key (carries the source record id / MRN) */
  search?: string | null;
  /** Filter by classify verdict (GDN-2287): one of new|unchanged|update|conflict|ambiguous, or 'unprocessable' for rows that failed validation. Applied server-side before pagination; omit or 'all' for every verdict. */
  verdict?: string | null;
  /** Filter by selection-working-set membership (GDN-2297): true = only selected rows, false = only unselected, omit = both. Applied server-side before pagination, like the other filters. */
  selected?: boolean | null;
  /** Filter by org-review flag (GDN-2300): true = only rows flagged for org review, false = only unflagged, omit = both. Applied server-side before pagination, like the other filters. */
  orgReviewNeeded?: boolean | null;
};
export type CommitStagedResourcesApiResponse =
  /** status 200 OK */ CommitStagedResourcesResponse;
export type CommitStagedResourcesApiArg = {
  sessionId: string;
  commitStagedResourcesRequest: CommitStagedResourcesRequest;
};
export type SetStagedResourcesOrgReviewApiResponse =
  /** status 200 OK */ OrgReviewResponse;
export type SetStagedResourcesOrgReviewApiArg = {
  sessionId: string;
  setOrgReviewRequest: SetOrgReviewRequest;
};
export type SelectStagedResourcesApiResponse =
  /** status 200 OK */ SelectionResponse;
export type SelectStagedResourcesApiArg = {
  sessionId: string;
  selectStagedResourcesRequest: SelectStagedResourcesRequest;
};
export type ClearStagedResourcesSelectionApiResponse =
  /** status 200 OK */ SelectionResponse;
export type ClearStagedResourcesSelectionApiArg = {
  sessionId: string;
  clearSelectionRequest: ClearSelectionRequest;
};
export type GetStagedResourcesSummaryApiResponse =
  /** status 200 OK */ StagedResourcesSummaryResponse;
export type GetStagedResourcesSummaryApiArg = {
  sessionId: string;
  /** Organization UUID */
  organizationId: string;
};
export type GetStagedResourceDocumentApiResponse =
  /** status 200 OK */ ArtifactContentResponse;
export type GetStagedResourceDocumentApiArg = {
  sessionId: string;
  importResourceId: string;
  /** Organization UUID */
  organizationId: string;
};
export type UploadImportFileApiResponse =
  /** status 200 OK */ ImportSessionCreateResponse;
export type UploadImportFileApiArg = {
  importUploadFormData: ImportUploadFormData;
};
export type ListOrgReviewPendingApiResponse =
  /** status 200 OK */ ListResponseOrgReviewItemSchema;
export type ListOrgReviewPendingApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter to one resource type (e.g. 'patient') */
  resourceType?: string | null;
};
export type ResolveOrgReviewRowApiResponse =
  /** status 200 OK */ OrgReviewResolveResponse;
export type ResolveOrgReviewRowApiArg = {
  importResourceId: string;
  orgReviewResolveRequest: OrgReviewResolveRequest;
};
export type PostV2ProviderDataMigrationPatientsDeduplicateApiResponse =
  /** status 200 OK */ FindDuplicatesResponse;
export type PostV2ProviderDataMigrationPatientsDeduplicateApiArg = {
  findDuplicatesRequest: FindDuplicatesRequest;
};
export type PostV2ProviderDataMigrationPatientsDeduplicateAutoMergeCandidatesApiResponse =
  /** status 200 OK */ FindAutoMergeCandidatesResponse;
export type PostV2ProviderDataMigrationPatientsDeduplicateAutoMergeCandidatesApiArg =
  {
    findAutoMergeCandidatesRequest: FindAutoMergeCandidatesRequest;
  };
export type PostV2ProviderDataMigrationPatientsDeduplicateBatchMergeApiResponse =
  /** status 202 Accepted */ BatchMergeAcceptedResponse;
export type PostV2ProviderDataMigrationPatientsDeduplicateBatchMergeApiArg = {
  batchMergeRequest: BatchMergeRequest;
};
export type GetV2ProviderDataMigrationPatientsDeduplicateBatchMergeByJobIdApiResponse =
  /** status 200 OK */ BatchMergeJobStatusResponse;
export type GetV2ProviderDataMigrationPatientsDeduplicateBatchMergeByJobIdApiArg =
  {
    jobId: string;
  };
export type PostV2ProviderDataMigrationPatientsDeduplicateDismissApiResponse =
  /** status 200 OK */ DismissDuplicateResponse;
export type PostV2ProviderDataMigrationPatientsDeduplicateDismissApiArg = {
  dismissDuplicateRequest: DismissDuplicateRequest;
};
export type PostV2ProviderDataMigrationPatientsDeduplicateMergeApiResponse =
  /** status 200 OK */ MergeGroupResponse;
export type PostV2ProviderDataMigrationPatientsDeduplicateMergeApiArg = {
  mergeGroupRequest: MergeGroupRequest;
};
export type ProviderListImportSessionsApiResponse =
  /** status 200 OK */ ImportSessionListResponse;
export type ProviderListImportSessionsApiArg = {
  /** Filter by status. Use 'active' for in-progress sessions, 'complete' for finished sessions, or a comma-separated list of raw status values. */
  statusFilter?: string | null;
  /** Maximum number of sessions to return */
  limit?: number;
  /** Number of sessions to skip for pagination */
  offset?: number;
};
export type ProviderDeleteImportSessionApiResponse = unknown;
export type ProviderDeleteImportSessionApiArg = {
  sessionId: string;
};
export type ProviderGetImportSessionStatusApiResponse =
  /** status 200 OK */ ImportSessionStatusResponse2;
export type ProviderGetImportSessionStatusApiArg = {
  sessionId: string;
};
export type ApproveCsvImportApiResponse =
  /** status 200 OK */ ApproveImportResponse;
export type ApproveCsvImportApiArg = {
  sessionId: string;
};
export type GetExtractedPatientsForReviewApiResponse =
  /** status 200 OK */ ExtractionReviewResponse;
export type GetExtractedPatientsForReviewApiArg = {
  sessionId: string;
  /** Maximum number of patients to return */
  limit?: number;
  /** Number of patients to skip for pagination */
  offset?: number;
};
export type ApproveReviewWizardApiResponse =
  /** status 200 OK */ ReviewApproveResponse;
export type ApproveReviewWizardApiArg = {
  sessionId: string;
  reviewApproveRequest: ReviewApproveRequest;
};
export type GetReviewPatientsApiResponse =
  /** status 200 OK */ ReviewPatientsResponse;
export type GetReviewPatientsApiArg = {
  sessionId: string;
  /** Review phase: 'new_patients', 'matched_patients', or 'appointments' */
  phase: ReviewPhase2;
  /** Page size */
  limit?: number;
  /** Number of items to skip */
  offset?: number;
};
export type GetReviewSummaryApiResponse =
  /** status 200 OK */ ReviewSummaryResponse;
export type GetReviewSummaryApiArg = {
  sessionId: string;
};
export type ProviderUploadImportFileApiResponse =
  /** status 200 OK */ MigrationSessionCreateResponse;
export type ProviderUploadImportFileApiArg = {
  importUploadFormData: ImportUploadFormData;
};
export type ConvertedIngestResponse = {
  /** True when a concurrent ingest was already running and the running session id was returned instead of starting a second run */
  already_running?: boolean;
  /** Converted batch id that was staged */
  batch_id: string;
  /** Set when nothing was staged (empty prefix or size cap) */
  blocked_reason?: string | null;
  /** Per-resource-type staged/invalid counts */
  counts_by_resource_type?: {
    [key: string]: {
      [key: string]: number;
    };
  };
  /** Number of envelope files read */
  files_processed?: number;
  /** Staging session id (null when blocked) */
  import_session_id?: string | null;
  /** Rows kept as invalid */
  invalid_count?: number;
  /** Organization the batch belongs to */
  organization_id: string;
  /** Converted S3 prefix the envelopes were read from */
  prefix?: string | null;
  /** Rows staged (valid envelopes) */
  staged_count?: number;
  /** Session status after kickoff, e.g. 'ingesting'. Poll get_staged_batch_status for progress and terminal counts. */
  status?: string | null;
};
export type MigrationErrorResponse = {
  /** Additional error details */
  details?: {
    [key: string]: any;
  } | null;
  /** Error type or category */
  error: string;
  /** Related session ID if applicable */
  session_id?: string | null;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type ConvertedIngestRequest = {
  /** Converted batch id — envelopes are read from 'v2/organizations/<org>/converted/<batch_id>/'. */
  batch_id: string;
  /** UUID of the organization the batch belongs to */
  organization_id: string;
};
export type ConvertedUploadItem = {
  /** Filename (e.g. `<resource_type>.jsonl`) */
  filename: string;
  /** Full S3 key of the object */
  key: string;
  /** Object size in bytes */
  size_bytes: number;
};
export type ConvertedUploadResponse = {
  /** Converted batch id — pass to `ingest_converted_batch` */
  batch_id: string;
  /** S3 bucket the files landed in */
  bucket: string;
  /** Number of files stored */
  count: number;
  /** The stored files */
  files?: ConvertedUploadItem[];
  /** Organization the files belong to */
  organization_id: string;
  /** Full S3 prefix the envelopes landed under */
  prefix: string;
  /** Filenames skipped as in-request duplicates */
  skipped?: string[];
};
export type ConvertedUploadFormData = {
  /** Converted batch id to write under (the id `ingest_converted_batch` reads). A new id is minted when omitted; re-uploading the same id overwrites that batch's files in place. */
  batch_id?: string | null;
  /** UUID of the organization */
  organization_id: string;
};
export type ErrorMessage = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportSessionStatusResponse = {
  completed_at: string | null;
  created_at: string;
  error_messages: ErrorMessage[];
  failed_patients: number;
  file_type: string;
  initializer_user_id: string | null;
  new_patients: number;
  organization_id: string;
  processed_patients: number;
  progress_percentage: number;
  session_id: string;
  status: string;
  total_patients: number;
  updated_at: string;
};
export type ImportSessionListResponse = {
  /** Organization ID these sessions belong to */
  organization_id: string;
  sessions: ImportSessionStatusResponse[];
  /** Total number of sessions returned */
  total: number;
};
export type RawUploadGroup = {
  /** Number of files in the upload */
  file_count: number;
  /** Friendly label (top-level folder/file name) */
  label: string;
  /** Full S3 prefix for the batch */
  prefix: string;
  /** Total size of the upload in bytes */
  total_size_bytes: number;
  /** UUID grouping the batch */
  upload_id: string;
};
export type RawUploadListResponse = {
  /** Raw uploads grouped by upload_id */
  uploads?: RawUploadGroup[];
};
export type ErrorMessage2 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type MergeMultiplePatientsResponse = {
  /** Number of existing patients soft-deleted */
  deleted_count?: number;
  /** List of merge errors */
  errors?: ErrorMessage2[];
  /** Number of merge operations that failed */
  failed_count?: number;
  /** Number of patients successfully merged */
  merged_count?: number;
  /** UUID of the target patient */
  target_patient_id: string;
};
export type ImportErrorResponse = {
  /** Additional error details */
  details?: {
    [key: string]: any;
  } | null;
  /** Error message */
  error: string;
  /** Session ID if available */
  session_id?: string | null;
};
export type MergeMultiplePatientsRequest = {
  /** Organization UUID for scoping */
  organization_id: string;
  /** List of existing patient UUIDs to merge and soft-delete */
  source_existing_patient_ids?: string[];
  /** List of extracted patient UUIDs to merge */
  source_extracted_patient_ids?: string[];
  /** Existing patient UUID to merge into (target) */
  target_patient_id: string;
};
export type RawUploadItem = {
  /** Filename / relative path under the upload */
  filename: string;
  /** Full S3 key of the object */
  key: string;
  /** Object size in bytes */
  size_bytes: number;
};
export type RawUploadResponse = {
  /** S3 bucket the files landed in */
  bucket: string;
  /** Number of files stored */
  count: number;
  /** The stored files */
  files?: RawUploadItem[];
  /** Organization the files belong to */
  organization_id: string;
  /** Relative paths skipped because an object with the same path already exists in the batch (existing objects are never overwritten). Only populated when appending to an existing batch. */
  skipped?: string[];
  /** UUID grouping the uploaded files */
  upload_id: string;
};
export type ImportUploadFormData = {
  /** UUID of the organization */
  organization_id: string;
  /** Existing raw-upload (batch) id to append these files to. When omitted, a new batch is created. Appending is only allowed while the batch is still pre-conversion (no import session yet). */
  upload_id?: string | null;
};
export type PresignRawUploadItem = {
  /** Content-Type signed into the URL; the client MUST send this exact value as the Content-Type header when it PUTs the file. */
  content_type: string;
  /** Filename / relative path under the upload */
  filename: string;
  /** Exact request headers the client MUST send with the PUT to `url` (includes Content-Type and the SSE-KMS header signed into the URL). A PUT missing these is denied by the bucket policy. */
  headers: {
    [key: string]: string;
  };
  /** Full S3 key the file will be stored at */
  key: string;
  /** Presigned HTTPS URL to PUT the file to */
  url: string;
};
export type PresignRawUploadResponse = {
  /** S3 bucket the files will land in */
  bucket: string;
  /** Presigned-PUT targets, one per file */
  files?: PresignRawUploadItem[];
  /** Relative paths skipped because an object with the same path already exists in the batch (existing objects are never overwritten). Only populated when appending to an existing batch. */
  skipped?: string[];
  /** UUID grouping the uploaded files */
  upload_id: string;
};
export type PresignRawUploadRequestFile = {
  /** Filename / relative path under the upload */
  filename: string;
};
export type PresignRawUploadRequest = {
  /** The files to presign (each a filename / relative path) */
  files: PresignRawUploadRequestFile[];
  /** UUID of the organization */
  organization_id: string;
  /** Existing raw-upload (batch) id to append these files to. When omitted, a new batch is created. Appending is only allowed while the batch is still pre-conversion (no import session yet). */
  upload_id?: string | null;
};
export type ResourceImportSessionSummary = {
  created_at?: string | null;
  import_session_id: string;
  import_stats?: {
    [key: string]: number;
  };
  organization_id: string;
  s3_prefix?: string | null;
  status: string;
  updated_at?: string | null;
};
export type ResourceImportSessionsListResponse = {
  items?: ResourceImportSessionSummary[];
  total?: number;
};
export type ErrorMessage3 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportSessionStatusResponse2 = {
  completed_at: string | null;
  created_at: string;
  error_messages: ErrorMessage3[];
  failed_patients: number;
  file_type: string;
  initializer_user_id: string | null;
  new_patients: number;
  organization_id: string;
  processed_patients: number;
  progress_percentage: number;
  session_id: string;
  status: string;
  total_patients: number;
  updated_at: string;
};
export type ArtifactContentResponse = {
  /** Best-effort content type by file extension */
  content_type: string;
  key: string;
  /** Full object size in bytes */
  size: number;
  /** UTF-8 decoded content (may be truncated) */
  text: string;
  /** True when the object exceeded the inline size cap */
  truncated: boolean;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ArtifactDownloadResponse = {
  expires_in: number;
  key: string;
  url: string;
};
export type ClassifyRequestedResponse = {
  enqueued?: boolean;
  import_session_id: string;
};
export type StagedResourcesOrgParams = {
  /** Organization UUID */
  organization_id: string;
};
export type ClassifyTypeCountsSchema = {
  /** verdict -> count, all five lanes zero-filled (new|unchanged|update|conflict|unprocessable) */
  counts?: {
    [key: string]: number;
  };
  resource_type: string;
};
export type ClassifySummaryResponse = {
  by_type?: ClassifyTypeCountsSchema[];
  import_session_id: string;
  organization_id: string;
  /** Human label for the batch source, e.g. the upload filename */
  source_label?: string | null;
  /** Total classified + unprocessable rows across all types */
  total_records?: number;
  /** Roll-up of by_type, per verdict lane */
  totals?: {
    [key: string]: number;
  };
};
export type ConflictFieldDiffSchema = {
  /** Value on the prior import */
  existing?: string | null;
  field: string;
  /** Value coming from this import */
  incoming?: string | null;
};
export type ConflictItemSchema = {
  /** Non-competing fills that merge automatically (FYI) */
  auto_merge?: ConflictFieldDiffSchema[];
  /** Fields where existing and incoming disagree (the decision) */
  competing?: ConflictFieldDiffSchema[];
  import_resource_id: string;
  /** 'exact' | 'high' | 'partial' | 'low' */
  match_confidence: string;
  /** 'confident' | 'uncertain' */
  match_kind: string;
  /** Label for the matched prior record (PHI) */
  matched_summary?: string | null;
  resource_type: string;
  source_key: string;
  /** Operator-facing label for the incoming record (PHI) */
  title?: string | null;
};
export type ConflictListResponse = {
  items?: ConflictItemSchema[];
  page?: number;
  per_page?: number;
  total?: number;
};
export type Allergy = {
  /** Name or description of the allergen */
  allergen: string;
  /** Whether the allergy is currently active */
  isActive?: boolean;
  /** Additional notes about the allergy */
  notes?: string | null;
  /** Date when allergy was first identified */
  onset_date?: string | null;
  /** Type of allergic reaction (hives, anaphylaxis, rash, etc.) */
  reaction?: string | null;
  /** Severity level (mild, moderate, severe, life-threatening) */
  severity?: string | null;
};
export type Diagnosis = {
  /** ICD-10 or other diagnostic code */
  code?: string | null;
  /** Date diagnosis was resolved */
  end_date?: string | null;
  /** Whether the diagnosis is currently active */
  isActive?: boolean;
  /** Name/description of the diagnosis */
  name: string;
  /** Date of diagnosis onset */
  start_date?: string | null;
};
export type Medication = {
  /** Dosage amount per administration */
  dosage_amount?: string | null;
  /** Date medication was discontinued */
  end_date?: string | null;
  /** Drug formulation (tablet, capsule, etc.) */
  formulation?: string | null;
  /** Frequency of administration (BID, qd, etc.) */
  frequency?: string | null;
  /** Generic drug name */
  generic_name?: string | null;
  /** Medical indication for the medication */
  indication?: string | null;
  /** Whether the medication is currently active */
  isActive?: boolean;
  /** Brand or common name of the medication */
  name: string;
  /** Route of administration (oral, IV, etc.) */
  route_of_administration?: string | null;
  /** Date medication was started */
  start_date?: string | null;
  /** Medication strength (e.g., '10 mg') */
  strength?: string | null;
  /** Specific timing instructions (HS, with meals, etc.) */
  timing?: string | null;
};
export type Procedure = {
  /** Procedure code (CPT, SNOMED, etc.) */
  code?: string | null;
  /** Date the procedure was performed */
  date_performed?: string | null;
  /** Whether this is a surgical procedure */
  isSurgical?: boolean;
  /** Location where procedure was performed */
  location?: string | null;
  /** Name of the procedure */
  name: string;
  /** Additional notes about the procedure */
  notes?: string | null;
  /** Outcome or result of the procedure */
  outcome?: string | null;
  /** Provider who performed the procedure */
  provider?: string | null;
};
export type SocialHistoryItem = {
  /** Category (smoking, alcohol, exercise, occupation, etc.) */
  category: string;
  /** Detailed description */
  description?: string | null;
  /** Date when this ended (if applicable) */
  end_date?: string | null;
  /** Quantity or frequency (e.g., '1 pack/day', '2 drinks/week') */
  quantity?: string | null;
  /** Date when this began */
  start_date?: string | null;
  /** Current status (current, former, never, etc.) */
  status: string;
};
export type PatientClinicalData = {
  /** List of patient allergies */
  allergies?: Allergy[];
  /** List of patient diagnoses */
  diagnoses?: Diagnosis[];
  /** List of patient medications */
  medications?: Medication[];
  /** List of medical procedures */
  procedures?: Procedure[];
  /** Social history items */
  social_history?: SocialHistoryItem[];
};
export type EmergencyContact = {
  /** Contact email address */
  email?: string | null;
  /** Contact full name */
  name?: string | null;
  /** Phone number in E.164 format (e.g., +12125551234) */
  phone?: string | null;
  /** Relationship to patient (spouse, parent, sibling, friend, etc.) */
  relationship?: string | null;
};
export type PatientAddress = {
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (apartment, suite, etc.) */
  line2?: string | null;
  /** Optional landline/location phone in E.164 format (e.g., +12125551234) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code (5 or 9 digit format, e.g., 12345 or 12345-6789) */
  zip?: string | null;
};
export type InsuranceInfo = {
  /** Whether authorization signature is on file */
  authorization_on_file?: boolean | null;
  /** S3 or storage location of authorization document for audit trail */
  authorization_resource_location?: string | null;
  /** Clearinghouse or EDI payer ID (e.g. 'UHC'). Import-time signal for payer resolution; not persisted to patient_insurance_coverages. */
  clearinghouse_payer_id?: string | null;
  /** Group number */
  group_number?: string | null;
  /** Address of insured if different from patient */
  insured_address?: PatientAddress | null;
  /** Date of birth of insured if different from patient */
  insured_dob?: string | null;
  /** Name of insured if different from patient */
  insured_name?: string | null;
  /** Sex of insured if different from patient (Male/Female) */
  insured_sex?: string | null;
  /** Patient's individual member/subscriber ID on their insurance card */
  member_id?: string | null;
  /** Insurance payer identifier code */
  payer_id?: string | null;
  /** Insurance company name */
  payer_name?: string | null;
  /** Specific plan or program name */
  plan_name?: string | null;
  /** Policy or plan contract number */
  policy_number?: string | null;
  /** Patient's relationship to insured (self, spouse, child, other) */
  relationship_to_insured?: string | null;
};
export type Patient = {
  /** Per-patient JotBill routing override: 'enabled', 'disabled', or None (inherit from org rule) */
  bill_with_jotpsych?: string | null;
  /** Record creation timestamp (UTC). */
  created_at?: string;
  /** ID of the principal (actor) that created this patient record. */
  created_by_principal_id?: string | null;
  /** Actor class that created the record: 'user' (provider), 'staff' (JotPsych platform staff), 'agent' (AI agent session), 'system' (background job), or 'patient'. */
  created_by_principal_kind?:
    | ("user" | "staff" | "agent" | "system" | "patient")
    | null;
  /** Soft-delete timestamp (UTC). None if the patient is not deleted. */
  deleted_at?: string | null;
  /** Date of birth in YYYY-MM-DD format (e.g., 1990-01-15) */
  dob?: string | null;
  /** Email address for patient communication */
  email?: string | null;
  /** Emergency contact information */
  emergency_contact?: EmergencyContact | null;
  /** Employment status (employed, unemployed, retired, student, etc.) */
  employment_status?: string | null;
  /** Patient's legal first name */
  first_name?: string | null;
  /** Patient's gender identity. Canonical values: 'male', 'female', 'transgender_male', 'transgender_female', 'non-binary', 'other', 'prefer_not_to_say'. Importers should map to one of these; other free text is tolerated on read but not preferred. */
  gender?: string | null;
  /** Patient height in inches (in). Required by DoseSpot for patients under 19. */
  height?: number | null;
  id?: string;
  /** External patient identifier or medical record number */
  identifier?: string | null;
  /** Patient's family name or surname */
  last_name?: string | null;
  /** Patient's middle name or initial */
  middle_name?: string | null;
  /** Primary mobile phone in E.164 format (e.g., +12125551234) for calls/texts */
  mobile_phone?: string | null;
  /** Patient's occupation or job title */
  occupation?: string | null;
  /** Owning organization (tenant) ID. */
  organization_id?: string | null;
  /** Whether patient authorization signature is on file */
  patient_consent_on_file?: boolean | null;
  /** S3 or storage location of consent document for audit trail */
  patient_consent_resource_location?: string | null;
  /** System patient ID (UUID), the primary key. Agents must set this field (not the inherited `id` alias) when writing. */
  patient_id: string;
  /** Patient's preferred name or nickname */
  preferred_name?: string | null;
  /** Primary residential address */
  primary_address?: PatientAddress | null;
  /** DEPRECATED - use PatientCoverage table */
  primary_insurance?: InsuranceInfo | null;
  /** Patient's preferred pronouns (he/him, she/her, they/them, etc.) */
  pronouns?: string | null;
  /** Patient's race or ethnicity */
  race?: string | null;
  /** Resource-protocol access scope; always "organization" for Patient. */
  scope?: "global" | "organization" | "user" | "patient";
  /** Secondary/mailing address if different from primary */
  secondary_address?: PatientAddress | null;
  /** DEPRECATED - use PatientCoverage table */
  secondary_insurance?: InsuranceInfo | null;
  /** Patient's sex for medical records and insurance claims. Canonical values: 'Male', 'Female'. Importers should map to one of these; other free text is tolerated on read but not preferred. */
  sex?: string | null;
  /** Stripe customer ID for patient-pays billing, if the patient has one. */
  stripe_customer_id?: string | null;
  /** DEPRECATED - use PatientCoverage table */
  tertiary_insurance?: InsuranceInfo | null;
  /** Last-updated timestamp (UTC). None for an unpersisted patient. */
  updated_at?: string | null;
  /** Resource-protocol owning-provider ID; unset for org-scoped patients. */
  user_id?: string | null;
  /** Patient weight in pounds (lb). Required by DoseSpot for patients under 19. */
  weight?: number | null;
};
export type MatchedPatientResult = {
  /** Confidence score of the match (0-100) */
  confidence: number;
  /** Complete patient data from main database */
  patient: Patient;
  /** Patient ID for reference */
  patient_id: string;
};
export type PatientImportStatus =
  | "extracted"
  | "new"
  | "matched"
  | "imported"
  | "merged"
  | "skipped"
  | "failed";
export type MigrationMetadata = {
  /** Migration session identifier */
  import_session_id: string;
  /** Status of this patient's import */
  import_status: PatientImportStatus;
  /** When the data was imported */
  imported_at: string;
  /** Original ID from source system */
  original_import_id?: string | null;
  /** Original source filename */
  source_file?: string | null;
};
export type MigratedPatient = {
  /** Clinical data (medications, diagnoses, etc.) */
  clinical_data?: PatientClinicalData | null;
  /** List of matched patients with full data and confidence scores */
  matched_patients?: MatchedPatientResult[] | null;
  /** Information about how/when this was migrated */
  migration_metadata?: MigrationMetadata | null;
  /** Patient demographics and basic info */
  patient: Patient;
};
export type MigratedDataResponse = {
  /** Number of patients returned */
  patient_count: number;
  /** List of migrated patient records */
  patients: MigratedPatient[];
  /** When this data was retrieved */
  retrieved_at: string;
  /** Migration session UUID */
  session_id: string;
};
export type ErrorMessage4 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ExtractedPatientsResponse = {
  /** List of import errors */
  errors?: ErrorMessage4[];
  /** Estimated duration for async operations */
  estimated_duration_seconds?: number | null;
  /** Number of patients that failed to import */
  failed_count?: number;
  /** Number of patients successfully imported (includes both new and updated) */
  imported_count?: number;
  /** Whether the import is processed asynchronously */
  is_async: boolean;
  /** UUID of the import operation */
  operation_id: string;
  /** Status of operation: 'processing' | 'completed' | 'failed' */
  operation_status: string;
  /** Import session UUID */
  session_id: string;
  /** Number of patients skipped */
  skipped_count?: number;
  /** Deprecated: Always 0. Use imported_count for total successful imports */
  updated_count?: number;
};
export type ExtractedPatientsRequest = {
  /** List of extracted patient UUIDs to import */
  patient_ids: string[];
  /** If True, do not create appointment records during import. Patient records are still imported / updated. */
  skip_appointments?: boolean;
  /** Whether to skip patients marked as duplicates */
  skip_duplicates?: boolean;
  /** If True, only update matched existing patients. Unmatched rows are skipped, not created. */
  skip_new_patients?: boolean;
  /** Whether to update existing patient records */
  update_existing?: boolean;
};
export type ErrorMessage5 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportOperationStatusResponse = {
  /** When processing completed */
  completed_at?: string | null;
  /** When the operation was created */
  created_at: string;
  /** Detailed error information */
  error_details?: ErrorMessage5[];
  /** Estimated duration in seconds */
  estimated_duration_seconds?: number | null;
  /** UUID of the operation */
  operation_id: string;
  /** Type of operation: 'import_selected' | 'import_unmatched' | 'merge_patients' */
  operation_type: string;
  /** Progress percentage */
  progress_percentage?: number;
  /** Number of patients processed */
  progress_processed_count?: number;
  /** Total number of patients to process */
  progress_total_count?: number;
  /** Number of patients that failed to import */
  results_failed_count?: number;
  /** Number of patients successfully imported */
  results_imported_count?: number;
  /** Number of patients skipped */
  results_skipped_count?: number;
  /** UUID of the import session */
  session_id: string;
  /** When processing started */
  started_at?: string | null;
  /** Current status: 'pending' | 'processing' | 'completed' | 'failed' */
  status: string;
  /** When the operation was last updated */
  updated_at: string;
};
export type ImportOperationListResponse = {
  /** List of operations */
  operations: ImportOperationStatusResponse[];
  /** UUID of the import session */
  session_id: string;
  /** Total number of operations */
  total: number;
};
export type ErrorMessage6 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportOperationStatusResponse2 = {
  /** When processing completed */
  completed_at?: string | null;
  /** When the operation was created */
  created_at: string;
  /** Detailed error information */
  error_details?: ErrorMessage6[];
  /** Estimated duration in seconds */
  estimated_duration_seconds?: number | null;
  /** UUID of the operation */
  operation_id: string;
  /** Type of operation: 'import_selected' | 'import_unmatched' | 'merge_patients' */
  operation_type: string;
  /** Progress percentage */
  progress_percentage?: number;
  /** Number of patients processed */
  progress_processed_count?: number;
  /** Total number of patients to process */
  progress_total_count?: number;
  /** Number of patients that failed to import */
  results_failed_count?: number;
  /** Number of patients successfully imported */
  results_imported_count?: number;
  /** Number of patients skipped */
  results_skipped_count?: number;
  /** UUID of the import session */
  session_id: string;
  /** When processing started */
  started_at?: string | null;
  /** Current status: 'pending' | 'processing' | 'completed' | 'failed' */
  status: string;
  /** When the operation was last updated */
  updated_at: string;
};
export type ErrorMessage7 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportUnmatchedResponse = {
  /** List of import errors */
  errors?: ErrorMessage7[];
  /** Estimated duration for async operations */
  estimated_duration_seconds?: number | null;
  /** Number of patients that failed to import */
  failed_count?: number;
  /** Number of patients successfully imported */
  imported_count?: number;
  /** Whether the import is processed asynchronously */
  is_async: boolean;
  /** UUID of the import operation */
  operation_id: string;
  /** Status of operation: 'processing' | 'completed' | 'failed' */
  operation_status: string;
  /** Import session UUID */
  session_id: string;
};
export type ImportUnmatchedRequest = {};
export type MatchedPatientInfo = {
  /** Confidence score (0-100) */
  confidence: number;
  /** Patient demographic data */
  patient_data?: {
    [key: string]: any;
  } | null;
  /** ID of the matched patient */
  patient_id: string;
};
export type MatchedPatientData = {
  /** Extracted patient UUID */
  extracted_patient_id: string;
  /** Import status */
  import_status: string;
  /** Decrypted extracted patient data */
  imported_patient_data?: {
    [key: string]: any;
  } | null;
  /** Fetched and decrypted best matched patient data from main database */
  matched_patient_data?: {
    [key: string]: any;
  } | null;
  /** ID of best matched patient in main database */
  matched_patient_id?: string | null;
  /** When matching was performed */
  matching_completed_at?: string | null;
  /** Confidence score of best match (0-100) */
  matching_confidence?: number | null;
  /** Original ID from source system */
  original_import_id?: string | null;
  /** All potential patient matches with confidence scores */
  potential_matches?: MatchedPatientInfo[] | null;
};
export type MatchedPatientsResponse = {
  /** Whether more patients exist beyond current page */
  has_more: boolean;
  /** Limit used for this request */
  limit: number;
  /** Number of patients with matches */
  matched_count: number;
  /** Number of patients not yet processed for matching */
  not_processed_count: number;
  /** Offset used for this request */
  offset: number;
  /** List of extracted patients with matching data */
  patients: MatchedPatientData[];
  /** Import session UUID */
  session_id: string;
  /** Total number of extracted patients */
  total_imported: number;
  /** Number of patients without matches */
  unmatched_count: number;
};
export type SessionPatientSchema = {
  counts?: {
    [key: string]: number;
  };
  name?: string | null;
  patient_committed_id?: string | null;
  patient_key: string;
  patient_staged?: boolean;
  total?: number;
};
export type SessionPatientsListResponse = {
  items?: SessionPatientSchema[];
  total?: number;
};
export type ErrorMessage8 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type BulkUpdateStatusResponse = {
  /** List of update errors */
  errors?: ErrorMessage8[];
  /** Number that failed to update */
  failed_count: number;
  /** Import session UUID */
  session_id: string;
  /** Number of patients updated */
  updated_count: number;
};
export type BulkUpdateStatusRequest = {
  /** Action to take */
  action: string;
  /** List of extracted patient UUIDs */
  patient_ids: string[];
  /** Reason for status change */
  reason?: string | null;
};
export type PatientMatchCandidateSchema = {
  confidence: number;
  dob?: string | null;
  identifier?: string | null;
  name?: string | null;
  patient_id: string;
  /** 'identifier' or 'demographic' */
  reason: string;
};
export type SessionPatientMatchSchema = {
  candidates?: PatientMatchCandidateSchema[];
  dob?: string | null;
  /** Incoming (staged) identifier/MRN — match evidence */
  identifier?: string | null;
  /** Why an ambiguous outcome needs a decision: 'identifier_collision' | 'weak_demographic_match' | 'ambiguous_identifier' | 'ambiguous_match' */
  match_basis?: string | null;
  name?: string | null;
  patient_key: string;
  /** 'matched' | 'ambiguous' | 'new' | 'invalid' */
  status: string;
};
export type SessionPatientMatchesListResponse = {
  items?: SessionPatientMatchSchema[];
  total?: number;
};
export type SourceProviderSchema = {
  counts?: {
    [key: string]: number;
  };
  /** Identity from the batch's staged provider envelope, when the converter emitted one (GDN-2256) */
  display_name?: string | null;
  provider_key: string;
  required?: boolean;
  total?: number;
};
export type SourceProvidersListResponse = {
  items?: SourceProviderSchema[];
  total?: number;
};
export type RejectPatientsResponse = {
  /** Number that failed to reject */
  failed_count: number;
  /** Number of patients rejected */
  rejected_count: number;
  /** Import session UUID */
  session_id: string;
};
export type RejectPatientsRequest = {
  /** List of extracted patient UUIDs to reject */
  patient_ids: string[];
  /** Reason for rejection */
  reason?: string | null;
};
export type StagedResourceSchema = {
  batch_id: string;
  /** Classify verdict: new|unchanged|update|conflict|ambiguous (NULL if unclassified) */
  classification?: string | null;
  commit_errors?: {
    [key: string]: any;
  }[];
  committed_resource_id?: string | null;
  created_at?: string | null;
  created_by_principal_id?: string | null;
  created_by_principal_kind?: string | null;
  data?: {
    [key: string]: any;
  };
  deferred?: string[];
  import_resource_id: string;
  import_session_id: string;
  /** In the session's shared selection working set (GDN-2297). Neutral membership that feeds Commit Selected — not a review verdict. */
  is_selected?: boolean;
  /** Entity-match candidates for an 'ambiguous' verdict: [{patient_id, confidence, reason}] — ids only, no PHI */
  match_candidates?:
    | {
        [key: string]: any;
      }[]
    | null;
  match_confidence?: number | null;
  org_review_at?: string | null;
  /** Provenance of the org-review flag: a user id, or 'agent' for an MCP-initiated flag. NULL unless org_review_needed. */
  org_review_by?: string | null;
  /** Flagged for org-level review (GDN-2300). Orthogonal to status: a flagged row keeps its status and is held out of the batch commit. Queue = flagged AND status staged. */
  org_review_needed?: boolean;
  /** Human labels for this row's refs, by role (e.g. {'patient': 'Ashley Clements'}) — resolved from the batch's staged patient/provider envelopes. A ref we can't resolve is omitted. */
  ref_labels?: {
    [key: string]: string;
  };
  refs?: {
    [key: string]: string;
  };
  resource_type: string;
  selected_at?: string | null;
  /** Provenance of the current selection: a user id, or 'agent' for an MCP-initiated pick. NULL unless is_selected. */
  selected_by?: string | null;
  source_key: string;
  source_system: string;
  status: string;
  updated_at?: string | null;
  validation_errors?: {
    [key: string]: any;
  }[];
};
export type ListResponseStagedResourceSchema = {
  items: StagedResourceSchema[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type CommitStagedResourcesResponse = {
  estimated_duration_seconds?: number;
  is_async?: boolean;
  operation_id: string;
  operation_status: string;
  total_count?: number;
};
export type ConflictResolution = {
  /** Conflict action, e.g. 'take_import', 'keep_existing', 'skip', 'import_as_new'. To send a conflict for org-level review, flag it with the org-review endpoint instead of deciding it here. */
  action: string;
  /** For 'take_import': overwrite only these competing fields (the rest keep the existing value). Omit or null to take all competing fields. */
  fields?: string[] | null;
};
export type PatientResolution = {
  /** 'link' to an existing patient or 'create' a new one */
  action: "link" | "create";
  /** Existing patient id to link to (required for 'link') */
  target_patient_id?: string | null;
};
export type CommitStagedResourcesRequest = {
  /** Operator decisions for conflicting rows, keyed by the staged row's import_resource_id. The value is either a bare action string ('skip', 'import_as_new', 'keep_existing', 'take_import') or an object {'action': ..., 'fields': [...]}. For 'take_import', 'fields' restricts the overwrite to those competing fields (the rest keep existing); omit 'fields' to take all. Every staged CONFLICT row in scope must carry an executable decision, unless it is flagged for org review (held out of the run), or the commit is blocked. */
  conflict_resolutions?: {
    [key: string]: string | ConflictResolution;
  } | null;
  /** Organization UUID */
  organization_id: string;
  /** Optional subset of patients to commit, by source key (e.g. ['patient:1']). Commits those patients and everything attached to them (the dependency closure); rows for other patients are left staged. Omit to commit every patient. */
  patient_keys?: string[] | null;
  /** Operator match decisions keyed by patient source key (e.g. {'patient:1': {'action': 'link', 'target_patient_id': '...'}}). Overrides automatic matching for that patient: 'link' to an existing patient (resolving an ambiguous match) or 'create' a new one. Patients without a resolution keep automatic behavior. */
  patient_resolutions?: {
    [key: string]: PatientResolution;
  } | null;
  /** Optional map of source provider keys (e.g. 'provider:npi:123') to platform user ids, used to attribute committed records */
  provider_mapping?: {
    [key: string]: string;
  };
  /** Optional subset of staged resource types to commit (e.g. ['patient']). Omit to commit every staged type. Children whose patients aren't committed yet block until the patients are. */
  resource_types?: string[] | null;
  /** Progressive dependents (GDN-2276): when committing child types, commit only the rows whose patient is already committed. A child of a still-staged patient is left staged (it can commit on a later run once its patient commits), NOT blocked; a child whose patient ref matches no patient in the session still blocks as a data error. Lets an operator land the dependents of the patients they've committed without resolving every remaining patient first. */
  scope_to_committed_patients?: boolean;
};
export type OrgReviewResponse = {
  /** The session's count of rows flagged for org review after the mutation. */
  org_review_total: number;
  /** Rows this call changed. */
  updated: number;
};
export type SetOrgReviewRequest = {
  /** Staged-resource UUIDs to toggle (scoped to this session). */
  import_resource_ids: string[];
  /** true to flag the rows for org review, false to unflag them. */
  needed: boolean;
  /** Organization UUID */
  organization_id: string;
};
export type SelectionResponse = {
  /** The session's selected count after the mutation. */
  selected_total: number;
  /** Rows this call changed. */
  updated: number;
};
export type SelectStagedResourcesRequest = {
  /** Staged-resource UUIDs to toggle (scoped to this session). */
  import_resource_ids: string[];
  /** Organization UUID */
  organization_id: string;
  /** true to add the rows to the selection, false to remove them. */
  selected: boolean;
};
export type ClearSelectionRequest = {
  /** Organization UUID */
  organization_id: string;
};
export type StagedResourcesSummaryResponse = {
  /** S3 object keys of the converter provenance artifacts */
  artifact_keys?: string[];
  /** S3 prefix of the converter provenance artifacts, if recorded */
  artifacts_prefix?: string | null;
  /** resource_type -> how many still-staged rows have an already-committed patient, i.e. would commit now under scope_to_committed_patients (GDN-2276). Powers the board's 'N ready / M waiting' progressive-dependents affordance. */
  commit_ready_by_type?: {
    [key: string]: number;
  };
  /** SHA-256 of the batch's convert.py, if recorded */
  converter_sha256?: string | null;
  counts_by_resource_type?: {
    [key: string]: {
      [key: string]: number;
    };
  };
  import_session_id: string;
  import_stats?: {
    [key: string]: number;
  };
  organization_id: string;
  s3_prefix?: string | null;
  status: string;
  /** resource_type -> session types it must wait for at commit, derived from each type's ref roles (GDN-2256) */
  waits_for?: {
    [key: string]: string[];
  };
};
export type ImportSessionCreateResponse = {
  /** When the session was created */
  created_at: string;
  /** S3 location of uploaded file */
  file_location?: string | null;
  /** Success message */
  message: string;
  /** UUID of the import session */
  session_id: string;
  /** Current status of the import */
  status: string;
};
export type ConflictFieldDiffSchema2 = {
  /** Value on the prior import */
  existing?: string | null;
  field: string;
  /** Value coming from this import */
  incoming?: string | null;
};
export type OrgReviewItemSchema = {
  /** Resolution actions valid for this row given its match state */
  allowed_actions?: string[];
  /** Non-competing fills that merge automatically (FYI) */
  auto_merge?: ConflictFieldDiffSchema2[];
  /** Classify verdict (new|unchanged|update|conflict|ambiguous) */
  classification?: string | null;
  /** Fields where existing and incoming disagree (the decision) */
  competing?: ConflictFieldDiffSchema2[];
  /** The incoming (staged) resource payload (PHI) */
  data?: {
    [key: string]: any;
  };
  import_resource_id: string;
  import_session_id: string;
  /** Entity-match candidates for an 'ambiguous' verdict: [{patient_id, confidence, reason}] — ids only, no PHI */
  match_candidates?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** 'exact' | 'high' | 'partial' | 'low' */
  match_confidence: string;
  /** 'confident' | 'uncertain' */
  match_kind: string;
  /** Existing resource this row matched, if any */
  matched_resource_id?: string | null;
  /** Label for the matched existing record (PHI) */
  matched_summary?: string | null;
  resource_type: string;
  source_key: string;
  /** Lifecycle status (staged while awaiting org review) */
  status: string;
  /** Operator-facing label for the incoming record (PHI) */
  title?: string | null;
};
export type ListResponseOrgReviewItemSchema = {
  items: OrgReviewItemSchema[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type OrgReviewResolveResponse = {
  /** Resource the row landed on, when one was written */
  committed_resource_id?: string | null;
  import_resource_id: string;
  /** The row's new status (committed|skipped) */
  status: string;
};
export type OrgReviewResolveRequest = {
  /** How to resolve the parked row */
  action:
    | "skip"
    | "import_as_new"
    | "keep_existing"
    | "take_import"
    | "survivorship";
  /** For 'survivorship': per competing field, whether to take the 'incoming' or keep the 'existing' value. Fills always apply; omitted competing fields keep the existing value. */
  field_overrides?: {
    [key: string]: "incoming" | "existing";
  } | null;
};
export type PatientSummarySchema = {
  created_at: string;
  date_of_birth?: string | null;
  email?: string | null;
  first_name?: string | null;
  insurance_payer_id?: string | null;
  insurance_policy_number?: string | null;
  insurance_provider?: string | null;
  last_appointment?: string | null;
  last_name?: string | null;
  mobile_phone?: string | null;
  patient_id: string;
};
export type PatientGroupSchema = {
  /** Average matching confidence (0-100) */
  confidence: number;
  /** Deterministic hash of patient IDs */
  group_id: string;
  /** Why these were grouped together */
  match_reasons: string[];
  patients: PatientSummarySchema[];
};
export type FindDuplicatesResponse = {
  duplicate_groups: PatientGroupSchema[];
  grouping_completed_at: string;
  organization_id: string;
  total_duplicates_found: number;
  total_patients: number;
};
export type FindDuplicatesRequest = {
  /** Minimum confidence score (0-100) to consider a match */
  confidence_threshold?: number;
  /** Organization UUID to search within */
  organization_id: string;
};
export type PatientSummarySchema2 = {
  created_at: string;
  date_of_birth?: string | null;
  email?: string | null;
  first_name?: string | null;
  insurance_payer_id?: string | null;
  insurance_policy_number?: string | null;
  insurance_provider?: string | null;
  last_appointment?: string | null;
  last_name?: string | null;
  mobile_phone?: string | null;
  patient_id: string;
};
export type AutoMergeCandidateSchema = {
  /** Average matching confidence (0-100) */
  confidence: number;
  /** Fields to fill on primary from secondaries */
  demographic_overrides: {
    [key: string]: string;
  };
  /** Deterministic hash of patient IDs */
  group_id: string;
  /** Why these were grouped together */
  match_reasons: string[];
  patients: PatientSummarySchema2[];
  /** Patient ID recommended as the merge target */
  suggested_primary_id: string;
};
export type FindAutoMergeCandidatesResponse = {
  auto_merge_candidates: AutoMergeCandidateSchema[];
  completed_at: string;
  organization_id: string;
  skipped_groups: number;
  total_duplicate_groups: number;
  total_patients: number;
};
export type FindAutoMergeCandidatesRequest = {
  /** Minimum confidence score (0-100) to consider a match */
  confidence_threshold?: number;
  /** Organization UUID to search within */
  organization_id: string;
};
export type BatchMergeAcceptedResponse = {
  /** Job ID for polling status */
  job_id: string;
  /** Human-readable status message */
  message?: string;
  /** Initial job status */
  status?: string;
  /** Number of groups to merge */
  total_groups: number;
};
export type BatchMergeGroupInput = {
  /** Field-value pairs to override on the primary patient after merge */
  demographic_overrides?: {
    [key: string]: string | null;
  } | null;
  /** Group ID from auto-merge candidates */
  group_id: string;
  /** Patient IDs to merge into primary */
  patient_ids_to_merge: string[];
  /** Patient to keep as primary */
  primary_patient_id: string;
};
export type BatchMergeRequest = {
  /** List of groups to merge */
  groups: BatchMergeGroupInput[];
  /** Organization UUID for scoping */
  organization_id: string;
};
export type BatchMergeGroupResultSchema = {
  error_message?: string | null;
  group_id: string;
  merged_patient_ids?: string[];
  primary_patient_id?: string | null;
  success: boolean;
};
export type BatchMergeJobStatusResponse = {
  completed_at?: string | null;
  created_at?: string | null;
  error_message?: string | null;
  failed?: number;
  job_id: string;
  processed_groups?: number;
  results?: BatchMergeGroupResultSchema[];
  started_at?: string | null;
  /** pending, processing, completed, or failed */
  status: string;
  successful?: number;
  total_groups?: number;
};
export type DismissDuplicateResponse = {
  dismissed: boolean;
  pairs_dismissed: number;
  patient_ids: string[];
};
export type DismissDuplicateRequest = {
  /** Organization UUID for scoping */
  organization_id: string;
  /** List of patient IDs to mark as not duplicates of each other */
  patient_ids: string[];
};
export type MergeGroupResponse = {
  allergies_merged?: number;
  appointment_series_deduplicated?: number;
  appointment_series_updated?: number;
  appointments_deduplicated?: number;
  appointments_updated?: number;
  coverages_updated?: number;
  diagnoses_merged?: number;
  documents_updated?: number;
  encounters_updated?: number;
  error_message?: string | null;
  form_sessions_updated?: number;
  invoices_updated?: number;
  medications_merged?: number;
  merged_patient_ids: string[];
  modules_copied?: number;
  notes_updated?: number;
  primary_patient_id: string;
  slugs_updated?: number;
  success: boolean;
  test_results_merged?: number;
};
export type ModuleItemSelection = {
  /** Index in that patient's module array */
  item_index: number;
  /** Module short name: diagnoses, medications, allergies, etc. */
  module_name: string;
  /** Which patient the item comes from */
  source_patient_id: string;
};
export type MergeGroupRequest = {
  /** Map of coverage_order ('1', '2', '3') to patient_id whose coverage to keep. If None, automatic timestamp-based conflict resolution is used. */
  coverage_selections?: {
    [key: string]: string;
  } | null;
  /** Field-value pairs to override on the primary patient's demographics after merge. Supported fields: first_name, last_name, dob, email, mobile_phone. If None, primary patient's demographics are kept as-is. */
  demographic_overrides?: {
    [key: string]: string | null;
  } | null;
  /** Cherry-picked module items. None=all-or-nothing merge, []=skip modules, populated=selective */
  module_selections?: ModuleItemSelection[] | null;
  /** Organization UUID for scoping */
  organization_id: string;
  /** List of patient IDs to merge into primary */
  patient_ids_to_merge: string[];
  /** Group ID (hash) of the duplicate group being merged */
  patient_match_group: string;
  /** Patient to keep as primary */
  primary_patient_id: string;
};
export type ApproveImportResponse = {
  /** Number of patients that failed to import */
  failed_count?: number;
  /** Number of patients successfully imported */
  imported_count?: number;
  /** Result message */
  message: string;
  /** Import session UUID */
  session_id: string;
  /** Updated session status */
  status: string;
};
export type ExtractedPatientReviewItem = {
  /** Formatted address string */
  address?: string | null;
  /** Secondary address line (apt, suite, unit) */
  address_line_2?: string | null;
  /** Appointment duration in minutes */
  appointment_duration?: number | null;
  /** Appointment type / encounter type */
  appointment_encounter_type?: string | null;
  /** Provider name from the CSV (optional — appointments can be org-level) */
  appointment_provider_name?: string | null;
  /** Display name of the matched provider in the system, null if no match or no provider in CSV */
  appointment_resolved_provider?: string | null;
  /** Appointment start time (ISO format) */
  appointment_start_time?: string | null;
  /** City */
  city?: string | null;
  /** Date of birth */
  dob?: string | null;
  /** Email address */
  email?: string | null;
  /** Emergency contact email */
  emergency_contact_email?: string | null;
  /** Emergency contact name */
  emergency_contact_name?: string | null;
  /** Emergency contact phone */
  emergency_contact_phone?: string | null;
  /** Emergency contact relationship */
  emergency_contact_relationship?: string | null;
  /** UUID of the extracted patient */
  extracted_patient_id: string;
  /** Patient's first name */
  first_name?: string | null;
  /** Gender */
  gender?: string | null;
  /** Insurance group number */
  group_number?: string | null;
  /** Patient identifier / MRN */
  identifier?: string | null;
  /** Current import status */
  import_status: string;
  /** Insurance policy number */
  insurance_policy_number?: string | null;
  /** Patient's last name */
  last_name?: string | null;
  /** Confidence tier: 'exact' (>=90), 'high' (>=70), or 'partial' (>=50) */
  match_confidence?: string | null;
  /** Match status for enrichment sessions: 'matched', 'ambiguous', or 'unmatched' */
  match_status?: string | null;
  /** UUID of the best-matched existing patient */
  matched_patient_id?: string | null;
  /** Display name of the best-matched existing patient */
  matched_patient_name?: string | null;
  /** Patient's middle name */
  middle_name?: string | null;
  /** Mobile phone number */
  mobile_phone?: string | null;
  /** Payer ID */
  payer_id?: string | null;
  /** Insurance payer name */
  payer_name?: string | null;
  /** Patient's preferred name */
  preferred_name?: string | null;
  /** Preferred pronouns */
  pronouns?: string | null;
  /** Race */
  race?: string | null;
  /** Relationship to insured (self, spouse, child, other) */
  relationship_to_insured?: string | null;
  /** Primary payer resolution confidence: high|medium|low|unresolved */
  resolved_payer_confidence?: string | null;
  /** Internal payer UUID resolved at extract time; non-null means the primary insurance was matched to a known payer in our system */
  resolved_payer_uuid?: string | null;
  /** Secondary insurance group number */
  secondary_group_number?: string | null;
  /** Secondary insurance policy/member ID number */
  secondary_insurance_policy_number?: string | null;
  /** Secondary insurance payer ID */
  secondary_payer_id?: string | null;
  /** Secondary insurance payer name */
  secondary_payer_name?: string | null;
  /** Secondary payer resolution confidence: high|medium|low|unresolved */
  secondary_resolved_payer_confidence?: string | null;
  /** Secondary payer UUID resolved at extract time */
  secondary_resolved_payer_uuid?: string | null;
  /** Biological sex */
  sex?: string | null;
  /** State */
  state?: string | null;
  /** Tertiary insurance group number */
  tertiary_group_number?: string | null;
  /** Tertiary insurance policy/member ID number */
  tertiary_insurance_policy_number?: string | null;
  /** Tertiary insurance payer ID */
  tertiary_payer_id?: string | null;
  /** Tertiary insurance payer name */
  tertiary_payer_name?: string | null;
  /** Tertiary payer resolution confidence: high|medium|low|unresolved */
  tertiary_resolved_payer_confidence?: string | null;
  /** Tertiary payer UUID resolved at extract time */
  tertiary_resolved_payer_uuid?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type ExtractionReviewResponse = {
  /** Whether more patients exist beyond current page */
  has_more: boolean;
  /** Limit used for this request */
  limit: number;
  /** Offset used for this request */
  offset: number;
  /** Extracted patients for review */
  patients: ExtractedPatientReviewItem[];
  /** Import session UUID */
  session_id: string;
  /** Total number of extracted patients */
  total_count: number;
};
export type ImportSessionStatus =
  | "pending"
  | "processing"
  | "in_progress"
  | "extracting"
  | "matching"
  | "ready_for_review"
  | "awaiting_schema_confirmation"
  | "ingesting"
  | "importing"
  | "completed"
  | "failed"
  | "cancelled";
export type ReviewApproveResponse = {
  /** Number of patients approved for import */
  approved_count: number;
  /** Import session UUID */
  session_id: string;
  /** Number of patients skipped (e.g. ambiguous) */
  skipped_count: number;
  /** Session status after approval */
  status: ImportSessionStatus;
};
export type ReviewApproveRequest = {
  /** If true, do not create appointment records during import. Patient records are still imported / updated. */
  skip_appointments?: boolean;
  /** If true, only update matched existing patients. Unmatched (new) patients in the session are skipped, not created. */
  skip_new_patients?: boolean;
};
export type Allergy2 = {
  /** Name or description of the allergen */
  allergen: string;
  /** Whether the allergy is currently active */
  isActive?: boolean;
  /** Additional notes about the allergy */
  notes?: string | null;
  /** Date when allergy was first identified */
  onset_date?: string | null;
  /** Type of allergic reaction (hives, anaphylaxis, rash, etc.) */
  reaction?: string | null;
  /** Severity level (mild, moderate, severe, life-threatening) */
  severity?: string | null;
};
export type Diagnosis2 = {
  /** ICD-10 or other diagnostic code */
  code?: string | null;
  /** Date diagnosis was resolved */
  end_date?: string | null;
  /** Whether the diagnosis is currently active */
  isActive?: boolean;
  /** Name/description of the diagnosis */
  name: string;
  /** Date of diagnosis onset */
  start_date?: string | null;
};
export type Medication2 = {
  /** Dosage amount per administration */
  dosage_amount?: string | null;
  /** Date medication was discontinued */
  end_date?: string | null;
  /** Drug formulation (tablet, capsule, etc.) */
  formulation?: string | null;
  /** Frequency of administration (BID, qd, etc.) */
  frequency?: string | null;
  /** Generic drug name */
  generic_name?: string | null;
  /** Medical indication for the medication */
  indication?: string | null;
  /** Whether the medication is currently active */
  isActive?: boolean;
  /** Brand or common name of the medication */
  name: string;
  /** Route of administration (oral, IV, etc.) */
  route_of_administration?: string | null;
  /** Date medication was started */
  start_date?: string | null;
  /** Medication strength (e.g., '10 mg') */
  strength?: string | null;
  /** Specific timing instructions (HS, with meals, etc.) */
  timing?: string | null;
};
export type NewPatientItem = {
  /** Formatted address string */
  address?: string | null;
  /** Secondary address line (apt, suite, unit) */
  address_line_2?: string | null;
  /** Allergies parsed from the record that will be added to the chart on import */
  allergies?: Allergy2[];
  /** City */
  city?: string | null;
  /** Diagnoses parsed from the record that will be added to the chart on import */
  diagnoses?: Diagnosis2[];
  /** Date of birth */
  dob?: string | null;
  /** Email address */
  email?: string | null;
  /** Emergency contact email */
  emergency_contact_email?: string | null;
  /** Emergency contact name */
  emergency_contact_name?: string | null;
  /** Emergency contact phone */
  emergency_contact_phone?: string | null;
  /** Emergency contact relationship */
  emergency_contact_relationship?: string | null;
  /** UUID of the extracted patient */
  extracted_patient_id: string;
  /** Patient's first name */
  first_name?: string | null;
  /** Gender */
  gender?: string | null;
  /** Insurance group / policy number */
  group_number?: string | null;
  /** Patient identifier / MRN */
  identifier?: string | null;
  /** Patient's last name */
  last_name?: string | null;
  /** Medications parsed from the record that will be added to the chart on import */
  medications?: Medication2[];
  /** Member / subscriber ID */
  member_id?: string | null;
  /** Patient's middle name */
  middle_name?: string | null;
  /** Mobile phone number */
  mobile_phone?: string | null;
  /** Payer ID */
  payer_id?: string | null;
  /** Insurance payer name */
  payer_name?: string | null;
  /** Patient's preferred name */
  preferred_name?: string | null;
  /** Preferred pronouns */
  pronouns?: string | null;
  /** Race */
  race?: string | null;
  /** Relationship to insured */
  relationship_to_insured?: string | null;
  /** Primary payer resolution confidence: high|medium|low|unresolved */
  resolved_payer_confidence?: string | null;
  /** Internal payer UUID resolved at extract time */
  resolved_payer_uuid?: string | null;
  /** Secondary insurance group / policy number */
  secondary_group_number?: string | null;
  /** Secondary member / subscriber ID */
  secondary_member_id?: string | null;
  /** Secondary payer ID */
  secondary_payer_id?: string | null;
  /** Secondary insurance payer name */
  secondary_payer_name?: string | null;
  /** Secondary relationship to insured */
  secondary_relationship_to_insured?: string | null;
  /** Secondary payer resolution confidence: high|medium|low|unresolved */
  secondary_resolved_payer_confidence?: string | null;
  /** Secondary payer UUID resolved at extract time */
  secondary_resolved_payer_uuid?: string | null;
  /** Biological sex */
  sex?: string | null;
  /** State */
  state?: string | null;
  /** Tertiary insurance group / policy number */
  tertiary_group_number?: string | null;
  /** Tertiary member / subscriber ID */
  tertiary_member_id?: string | null;
  /** Tertiary payer ID */
  tertiary_payer_id?: string | null;
  /** Tertiary insurance payer name */
  tertiary_payer_name?: string | null;
  /** Tertiary relationship to insured */
  tertiary_relationship_to_insured?: string | null;
  /** Tertiary payer resolution confidence: high|medium|low|unresolved */
  tertiary_resolved_payer_confidence?: string | null;
  /** Tertiary payer UUID resolved at extract time */
  tertiary_resolved_payer_uuid?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type MatchConfidenceTier = "exact" | "high" | "partial" | "low";
export type MatchedPatientItem = {
  /** Allergies parsed from the record that will be added to the chart on import */
  allergies?: Allergy2[];
  /** Diagnoses parsed from the record that will be added to the chart on import */
  diagnoses?: Diagnosis2[];
  /** Fields where existing is empty but incoming has a value */
  enrichment_fields?: string[];
  /** Current values for the same fields on the existing patient */
  existing: {
    [key: string]: any;
  };
  /** UUID of the extracted patient */
  extracted_patient_id: string;
  /** Enrichable fields from the CSV row */
  incoming: {
    [key: string]: any;
  };
  /** Confidence tier for the match */
  match_confidence: MatchConfidenceTier;
  /** UUID of the matched existing patient */
  matched_patient_id: string;
  /** Display name of the matched patient */
  matched_patient_name?: string | null;
  /** Medications parsed from the record that will be added to the chart on import */
  medications?: Medication2[];
  /** Primary payer resolution confidence: high|medium|low|unresolved */
  resolved_payer_confidence?: string | null;
  /** Internal payer UUID resolved at extract time */
  resolved_payer_uuid?: string | null;
  /** Secondary payer resolution confidence: high|medium|low|unresolved */
  secondary_resolved_payer_confidence?: string | null;
  /** Secondary payer UUID resolved at extract time */
  secondary_resolved_payer_uuid?: string | null;
  /** Tertiary payer resolution confidence: high|medium|low|unresolved */
  tertiary_resolved_payer_confidence?: string | null;
  /** Tertiary payer UUID resolved at extract time */
  tertiary_resolved_payer_uuid?: string | null;
};
export type AppointmentItem = {
  /** Appointment duration in minutes */
  appointment_duration?: number | null;
  /** Appointment type / encounter type */
  appointment_encounter_type?: string | null;
  /** Appointment start time (ISO format) */
  appointment_start_time?: string | null;
  /** UUID of the extracted patient */
  extracted_patient_id: string;
  /** Patient's first name */
  first_name?: string | null;
  /** Patient's last name */
  last_name?: string | null;
  /** 'matched', 'unmatched', or 'ambiguous' */
  match_status?: string | null;
  /** Display name of the resolved system provider. Null if the CSV provider name could not be matched to an org member. */
  provider_name?: string | null;
};
export type ReviewPhase = "new_patients" | "matched_patients" | "appointments";
export type ReviewPatientsResponse = {
  /** Whether more items exist beyond this page */
  has_more: boolean;
  /** Phase-specific item objects */
  items: (NewPatientItem | MatchedPatientItem | AppointmentItem)[];
  /** Page size used */
  limit: number;
  /** Offset used */
  offset: number;
  /** Review phase name */
  phase: ReviewPhase;
  /** Import session UUID */
  session_id: string;
  /** Total items in this phase */
  total_count: number;
};
export type ReviewPhase2 = "new_patients" | "matched_patients" | "appointments";
export type ReviewSummaryResponse = {
  /** Multi-match patients (skipped on import) */
  ambiguous_patients: number;
  /** Patients with appointment data */
  appointments: number;
  /** Single-match patients to enrich */
  matched_patients: number;
  /** Unmatched patients to create */
  new_patients: number;
  /** Import session UUID */
  session_id: string;
  /** Total extracted patients in session */
  total_records: number;
};
export type ImportSessionStatus2 =
  | "pending"
  | "processing"
  | "in_progress"
  | "extracting"
  | "matching"
  | "ready_for_review"
  | "awaiting_schema_confirmation"
  | "ingesting"
  | "importing"
  | "completed"
  | "failed"
  | "cancelled";
export type MigrationSessionCreateResponse = {
  /** When the session was created */
  created_at: string;
  /** S3 location of uploaded file */
  file_location: string;
  /** Human-readable status message */
  message: string;
  /** Migration session UUID */
  session_id: string;
  /** Current session status */
  status: ImportSessionStatus2;
};
export const {
  useConvertedIngestBatchMutation,
  useConvertedUploadEnvelopesMutation,
  useListOrganizationImportSessionsQuery,
  useListOrgRawUploadsQuery,
  useMergeMultiplePatientsMutation,
  useRawUploadImportFileMutation,
  usePresignRawUploadUrlsMutation,
  useListResourceImportSessionsQuery,
  useDeleteImportSessionMutation,
  useGetImportSessionStatusQuery,
  useGetSessionArtifactContentQuery,
  useDownloadSessionArtifactQuery,
  useRequestClassifyMutation,
  useGetClassifySummaryQuery,
  useListClassifyConflictsQuery,
  useExportImportResultsQuery,
  useImportSelectedPatientsMutation,
  useListImportOperationsQuery,
  useGetImportOperationStatusQuery,
  useImportUnmatchedPatientsMutation,
  useGetMatchedPatientsQuery,
  useListSessionPatientsQuery,
  useBulkUpdatePatientStatusMutation,
  useListSessionPatientMatchesQuery,
  useListSourceProvidersQuery,
  useRejectPatientsMutation,
  useListStagedResourcesQuery,
  useCommitStagedResourcesMutation,
  useSetStagedResourcesOrgReviewMutation,
  useSelectStagedResourcesMutation,
  useClearStagedResourcesSelectionMutation,
  useGetStagedResourcesSummaryQuery,
  useGetStagedResourceDocumentQuery,
  useUploadImportFileMutation,
  useListOrgReviewPendingQuery,
  useResolveOrgReviewRowMutation,
  usePostV2ProviderDataMigrationPatientsDeduplicateMutation,
  usePostV2ProviderDataMigrationPatientsDeduplicateAutoMergeCandidatesMutation,
  usePostV2ProviderDataMigrationPatientsDeduplicateBatchMergeMutation,
  useGetV2ProviderDataMigrationPatientsDeduplicateBatchMergeByJobIdQuery,
  usePostV2ProviderDataMigrationPatientsDeduplicateDismissMutation,
  usePostV2ProviderDataMigrationPatientsDeduplicateMergeMutation,
  useProviderListImportSessionsQuery,
  useProviderDeleteImportSessionMutation,
  useProviderGetImportSessionStatusQuery,
  useApproveCsvImportMutation,
  useGetExtractedPatientsForReviewQuery,
  useApproveReviewWizardMutation,
  useGetReviewPatientsQuery,
  useGetReviewSummaryQuery,
  useProviderUploadImportFileMutation,
} = injectedRtkApi;
